<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <div style="position: absolute;">
        <v-btn @click="$router.go(-1)" text class="pl-0">
          <v-icon class="mr-1" size="15px"> mdi-arrow-left </v-icon>
          <span class="text-return mon-regular" style="font-family: 'montserrat-medium';">{{ "Regresar" }}</span>
        </v-btn>
      </div>
      <div class="mt-8 mb-6" style="font-family: 'montserrat-semibold'; font-size: 32px; color: #193D6E;">{{ "Detalle del beneficiario: " + paymentRecipient.sName }}</div>
      <div class="beneficiary-container">
        <v-card class="beneficiary-card" elevation="0" style="background-color: white; border-radius: 10px; border: 1px solid #bfc3ca;">
          <v-row>
            <div class="section-title">Información del beneficiario</div>
          </v-row>
          <v-row>
            <div class="info-grid">
              <div style="display: flex; flex-wrap: wrap">
                <div style="display: flex; flex-direction: column; margin-right: 35px; margin-top: 10px" v-if="paymentRecipient.sName">
                  <div class="info-field" style="color: #A3A3A3; font-family: 'montserrat-bold';">
                    {{ "Nombre" }}
                  </div>
                  <div style="color: #193D6E; font-family: 'montserrat-bold';">
                    {{ paymentRecipient.sName }}
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; margin-right: 35px; margin-top: 10px" v-if="paymentRecipient.sTaxId">
                  <div class="info-field" style="color: #A3A3A3; font-family: 'montserrat-bold';">
                    {{ "RFC" }}
                  </div>
                  <div style="color: #193D6E; font-family: 'montserrat-bold';">
                    {{ paymentRecipient.sTaxId }}
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; margin-right: 35px; margin-top: 10px" v-if="paymentRecipient.sAddressLine">
                  <div class="info-field" style="color: #A3A3A3; font-family: 'montserrat-bold';">
                    {{ "Dirección" }}
                  </div>
                  <div style="color: #193D6E; font-family: 'montserrat-bold';">
                    {{ paymentRecipient.sAddressLine }}
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; margin-right: 35px; margin-top: 10px" v-if="paymentRecipient.sCity">
                  <div class="info-field" style="color: #A3A3A3; font-family: 'montserrat-bold';">
                    {{ "Ciudad" }}
                  </div>
                  <div style="color: #193D6E; font-family: 'montserrat-bold';">
                    {{ paymentRecipient.sCity }}
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; margin-right: 35px; margin-top: 10px" v-if="paymentRecipient.sState">
                  <div class="info-field" style="color: #A3A3A3; font-family: 'montserrat-bold';">
                    {{ "Estado" }}
                  </div>
                  <div style="color: #193D6E; font-family: 'montserrat-bold';">
                    {{ paymentRecipient.sState }}
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; margin-right: 35px; margin-top: 10px" v-if="paymentRecipient.postCode">
                  <div class="info-field" style="color: #A3A3A3; font-family: 'montserrat-bold';">
                    {{ "Código Postal" }}
                  </div>
                  <div style="color: #193D6E; font-family: 'montserrat-bold';">
                    {{ paymentRecipient.postCode }}
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; margin-right: 35px; margin-top: 10px" v-if="paymentRecipient.sCountry">
                  <div class="info-field" style="color: #A3A3A3; font-family: 'montserrat-bold';">
                    {{ "País" }}
                  </div>
                  <div style="color: #193D6E; font-family: 'montserrat-bold';">
                    {{ paymentRecipient.sCountry }}
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; margin-right: 35px; margin-top: 10px" v-if="paymentRecipient.sEmail">
                  <div class="info-field" style="color: #A3A3A3; font-family: 'montserrat-bold';">
                    {{ "Email" }}
                  </div>
                  <div style="color: #193D6E; font-family: 'montserrat-bold';">
                    {{ paymentRecipient.sEmail }}
                  </div>
                </div>
              </div>
            </div>
          </v-row>
        </v-card>
        <v-card class="beneficiary-card" elevation="0" style="background-color: white; border-radius: 10px; border: 1px solid #bfc3ca;">
          <v-row>
            <div class="section-title">Información bancaria</div>
          </v-row>
          <v-row>
            <div class="info-grid">
              <div style="display: flex; flex-wrap: wrap">
                <div style="display: flex; flex-direction: column; margin-right: 35px; margin-top: 10px" v-if="paymentRecipient.sBankName">
                  <div class="info-field" style="color: #A3A3A3; font-family: 'montserrat-bold';">
                    {{ "Banco:" }}
                  </div>
                  <div style="color: #193D6E; font-family: 'montserrat-bold';">
                    {{ paymentRecipient.sBankName }}
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; margin-right: 35px; margin-top: 10px" v-if="paymentRecipient.sAccountCurrency">
                  <div class="info-field" style="color: #A3A3A3; font-family: 'montserrat-bold';">
                    {{ "Moneda" }}
                  </div>
                  <div style="color: #193D6E; font-family: 'montserrat-bold';">
                    {{ paymentRecipient.sAccountCurrency }}
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; margin-right: 35px; margin-top: 10px" v-if="paymentRecipient.swiftCode">
                  <div class="info-field" style="color: #A3A3A3; font-family: 'montserrat-bold';">
                    {{ "SWIFT" }}
                  </div>
                  <div style="color: #193D6E; font-family: 'montserrat-bold';">
                    {{ paymentRecipient.swiftCode }}
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; margin-right: 35px; margin-top: 10px" v-if="paymentRecipient.sAccountNumber">
                  <div class="info-field" style="color: #A3A3A3; font-family: 'montserrat-bold';">
                    {{ "Número de cuenta" }}
                  </div>
                  <div style="color: #193D6E; font-family: 'montserrat-bold';">
                    {{ paymentRecipient.sAccountNumber }}
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; margin-right: 35px; margin-top: 10px" v-if="paymentRecipient.accountNumber">
                  <div class="info-field" style="color: #A3A3A3; font-family: 'montserrat-bold';">
                    {{ "Número de cuenta" }}
                  </div>
                  <div style="color: #193D6E; font-family: 'montserrat-bold';">
                    {{ paymentRecipient.accountNumber }}
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; margin-right: 35px; margin-top: 10px" v-if="paymentRecipient.sRoutingNumber">
                  <div class="info-field" style="color: #A3A3A3; font-family: 'montserrat-bold';">
                    {{ "Routing number" }}
                  </div>
                  <div style="color: #193D6E; font-family: 'montserrat-bold';">
                    {{ paymentRecipient.sRoutingNumber }}
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; margin-right: 35px; margin-top: 10px" v-if="paymentRecipient.sAccountType">
                  <div class="info-field" style="color: #A3A3A3; font-family: 'montserrat-bold';">
                    {{ "Tipo de cuenta" }}
                  </div>
                  <div style="color: #193D6E; font-family: 'montserrat-bold';">
                    {{ paymentRecipient.sAccountType }}
                  </div>
                </div>
              </div>
            </div>
          </v-row>
        </v-card>
      </div>
      <v-row class="ma-0 mb-2 mt-4">
        <div style="font-family: 'montserrat-semibold'; font-size: 28px; color: #193D6E;">{{ "Detalle de pagos" }}</div>
      </v-row>
      <div style="display: flex; gap: 40px; flex-wrap: wrap; margin-top: 14px; margin-bottom: 24px">
        <div style="flex: 1; min-width: 280px; border: 1px solid #bfc3ca; border-radius: 10px; background-color: white; padding: 24px; text-align: center;">
          <div style="font-weight: bold; font-size: 16px; margin-bottom: 8px; color: #A3A3A3">Monto total pagado</div>
          <div style="font-size: 18px; font-family: 'montserrat-bold'; color: #193D6E;">$ {{ formatMoney(totalDepositedAmount) + " " + paymentRecipient.sAccountCurrency }}</div>
        </div>
        <div style="flex: 1; min-width: 280px; border: 1px solid #bfc3ca; border-radius: 10px; background-color: white; padding: 24px; text-align: center;">
          <div style="font-weight: bold; font-size: 16px; margin-bottom: 8px; color: #A3A3A3">Total de pagos</div>
          <div style="font-size: 18px; font-family: 'montserrat-bold'; color: #193D6E;">{{ totalValidPayments }}</div>
        </div>
        <div style="flex: 1; min-width: 280px; border: 1px solid #bfc3ca; border-radius: 10px; background-color: white; padding: 24px; text-align: center;">
          <div style="font-weight: bold; font-size: 16px; margin-bottom: 8px; color: #A3A3A3">Promedio por ticket</div>
          <div style="font-size: 18px; font-family: 'montserrat-bold'; color: #193D6E;">$ {{ formatMoney(averageDepositedAmount) + " " + paymentRecipient.sAccountCurrency }}</div>
        </div>
      </div>
      <div class="mt-6" style="background-color: white; border-radius: 10px; border: 1px solid #bfc3ca; padding: 15px">
        <v-row class="ma-0">
          <v-col class="pa-0 my-4">
            <v-text-field
              v-model="busqueda"
              placeholder="Buscar"
              clearable
              hide-details
              outlined
              style="width: 300px; font-family: 'montserrat-medium'; border-radius: 20px;"
              prepend-inner-icon="mdi-magnify"
            />
          </v-col>
          <v-col class="d-flex justify-end pa-0 my-4" style="align-items: center;">
            <v-btn color="#0075B8" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #0075BB; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSX()">
              <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
              {{ "Descargar" }}
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table class="d-none d-sm-block" :items-per-page="5" hide-default-header :items="payments" style="background-color: white !important">
          <template v-slot:header="{ props }">
            <thead style="background-color: #f9fafd;">
              <tr>
                <th class="header__title left">{{ "Id" }}</th>
                <th class="header__title center">{{ "Fecha de pago" }}</th>
                <th class="header__title center">{{ "Beneficiario" }}</th>
                <th class="header__title center">{{ "Status" }}</th>
                <th class="header__title center">{{ "Tipo de cambio" }}</th>
                <th class="header__title center">{{ "Monto origen" }}</th>
                <th class="header__title center">{{ "Monto destino" }}</th>
                <th class="header__title center">{{ "Currency gain" }}</th>
                <th class="header__title center">{{ "Profit (%)" }}</th>
                <th class="header__title right">{{ "Acciones" }}</th>
              </tr>
            </thead>
          </template>
          <template v-slot:body="{ items }">
            <tbody style="background: #f9fafd;">
              <tr v-for="item in items" :key="item.id">
                <td class="table__item">{{ item.iTrackingId }}</td>
                <td class="table__item">{{ formatDate(item.created_at) }}</td>
                <td class="table__item">{{ item.PaymentRecipient}}</td>
                <td class="table__item">
                  <v-chip :color="setStatusColor(item.StatusPayments)" class="ma-2" outlined>
                    {{ item.StatusPayments }}
                  </v-chip>
                </td>
                <td class="table__item">{{  item.dRate ? "$ " + formatMoney(item.dRate) + " MXN" : "-" }}</td>
                <td class="table__item">{{ "$ " + formatMoney(item.dPaymentAmount) + " " + (item.sCurrency ? item.sCurrency : "USD") }}</td>
                <td class="table__item">{{ "$ " + formatMoney(item.dDescAmount) + " " + (item.sDestCurrency ? item.sDestCurrency : "MXN") }}</td>
                <td class="table__item" :style="item.dCurrencyGain == 0 ? 'color: #193D6E;' : (item.dCurrencyGain > 0 ? 'color: #4CAF50;' : 'color: #E74C3C;')">{{ item.dCurrencyGain ? ('$ ' + formatMoney(item.dCurrencyGain) + ' ' + ($store.state.sTypeAccount == 'EFEXUSD' ? 'USD' : 'MXN')) : "-" }}</td>
                <td class="table__item" :style="item.dProfitPercentage == 0 ? 'color: #193D6E;' : (item.dProfitPercentage > 0 ? 'color: #4CAF50;' : 'color: #E74C3C;')">{{ item.dProfitPercentage ? formatMoney(item.dProfitPercentage) + "%" : "-" }}</td>
                <td class="table__item">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="openDetail(item)" v-bind="attrs" v-on="on" icon color="black">
                        <v-icon>mdi-eye-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Detalle</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="getReceipt(item)"
                        v-bind="attrs"
                        v-on="on"
                        icon
                        color="black"
                        :disabled="item.StatusPayments !== 'COMPLETED' && item.StatusPayments !== 'DEPOSITED'"
                      >
                        <v-icon>mdi-invoice-text-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Descargar comprobante</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="getCep(item)"
                        v-bind="attrs"
                        v-on="on"
                        icon
                        color="black"
                        :disabled="item.StatusPayments !== 'COMPLETED' && item.StatusPayments !== 'DEPOSITED'"
                      >
                        <v-icon>mdi-receipt-text</v-icon>
                      </v-btn>
                    </template>
                    <span>Descargar cep</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export default {
  name: "BeneficiaryDetail",
  data() {
    return {
      nameXLSX: "Payments.xlsx",
      isLoading: false,
      texts: "",
      busqueda: "",
      paymentsRaw: [],
      paymentRecipient: {},
      averageDepositedAmount: 0,
      totalValidPayments: 0,
      totalDepositedAmount: 0,
    };
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
    payments() {
      if (!this.busqueda) return this.paymentsRaw;

      const filtro = this.busqueda.toLowerCase();

      return this.paymentsRaw.filter((item) => {
        const formattedRate = item.dRate ? `$ ${this.formatMoney(item.dRate)} MXN` : '-';
        const formattedPaymentAmount = `$ ${this.formatMoney(item.dPaymentAmount)} ${item.sCurrency || 'USD'}`;
        const formattedDescAmount = `$ ${this.formatMoney(item.dDescAmount)} ${item.sDestCurrency || 'MXN'}`;
        const formattedDate = this.formatDate(item.created_at);

        return (
          String(item.iTrackingId).toLowerCase().includes(filtro) ||
          formattedDate.toLowerCase().includes(filtro) ||
          item.PaymentRecipient?.toLowerCase().includes(filtro) ||
          item.StatusPayments?.toLowerCase().includes(filtro) ||
          formattedRate.toLowerCase().includes(filtro) ||
          formattedPaymentAmount.toLowerCase().includes(filtro) ||
          formattedDescAmount.toLowerCase().includes(filtro)
        );
      });
    },
  },
  methods: {
    getBeneficiary() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/en/payment-recipient/beneficiary/${this.$route.params.sPaymentRecipientId}`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      }).then((response) => {
        this.paymentRecipient = response.data.paymentRecipient
        this.paymentsRaw = response.data.payments;

        const validPayments = this.paymentsRaw.filter(p =>
          ['DEPOSITED', 'COMPLETED'].includes(p.StatusPayments)
        );

        // Cantidad de pagos
        this.totalValidPayments = validPayments.length;

        // Suma total de dDescAmount
        this.totalDepositedAmount = validPayments.reduce(
          (sum, p) => sum + Number(p.dDescAmount || 0),
          0
        );

        // Promedio
        this.averageDepositedAmount = this.totalValidPayments > 0
          ? this.totalDepositedAmount / this.totalValidPayments
          : 0;

        this.isLoading = false;
      }).catch((error) => {
        if (error.response.data.code) {
          this.$router.push("/welcome").catch(() => {});
        }
        this.mixError(error.response.data.message, error.response.status);
      });
    },
    formatMoney: function (value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(formattedNumber);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    dataXLSX() {
      try {
        const data = this.paymentsRaw.map((item) => ({
          "ID de seguimiento": item.iTrackingId || "-",
          "Fecha de creación": item.created_at ? this.formatDate(item.created_at) : "-",
          Beneficiario: item.PaymentRecipient || "-",
          Estatus: item.StatusPayments || "-",
          "Tipo de cambio": item.dRate ? `${this.formatMoney(item.dRate)}` : "-",
          "Monto original": `${this.formatMoney(item.dPaymentAmount)}`,
          "Monto convertido": `${this.formatMoney(item.dDescAmount)}`,
          "Currency Origen": item.sCurrency || 'USD',
          "Currency Destino": item.sDestCurrency || 'MXN'
        }));

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Egresos");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        saveAs(blob, "Egresos.xlsx");

        this.success = true;
        this.msgSuccess = "Descargando egresos";
      } catch (error) {
        console.log(error);
        this.error = true;
        this.codeError = "XLSX_EXPENSES_FAILED";
      }
    },
    setStatusColor(status) {
      if (status === "COMPLETED" || status === "DEPOSITED") {
        return "green";
      } else if(status === "PENDING_TO_PROCESS"){
        return "blue";
      } else if(status === "PENDING_TO_DEPOSIT"){
        return "blue";
      } else if(status === "REJECTED"){
        return "red";
      }
      else {
        return "gray";
      }
    },
    openDetail(item) {
      this.$router.push({
        name: "Payment",
        params: { idPayment: item.sPaymentId }
      }).catch(() => {});
    },
    getReceipt(item) {
      this.loading = true;
      const payload = {
        sPaymentId: item.sPaymentId,
      };

      console.log("PAYLOAD RECEIPT", payload);

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/payments/openReceipt`, payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          },
          responseType: 'blob'
        }
      )
      .then((response) => {
        console.log("RESPONSE RECEIPT", response);
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${item.PaymentRecipient + (item.invoice ? "_" + item.invoice : "")}.pdf`;
        link.click();
      })
      .catch((error) => {
        this.mixError(
          error?.response?.data?.message || "No se pudo descargar el archivo",
          error?.response?.status || 500
        );
      })
      .finally(() => {
        this.loading = false;
      });
    },
    getCep(item) {
      this.loading = true;
      const payload = {
        sPaymentId: item.sPaymentId,
        sEnterpriseId: item.sEnterpriseId,
      };

      DB.post(
        `${URI}/api/v1/en/customer/payment/getCep`, payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
      .then((response) => {
        const url = response.data.paymentCep;
        if (url) {
          window.open(url, "_blank");
        } else {
          this.mixError("Error al descargar el cep.", 400);
        }
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.loading = false;
      });
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.takeRate[this.selectLanguage];
      }
    },
  },
  beforeMount() {
    this.texts = FILE.takeRate[this.selectLanguage];
    this.getBeneficiary();
  },
};
</script>

<style scoped>
.section-title {
  font-family: 'montserrat-bold';
  color: #193D6E;
  font-size: 18px;
  margin-bottom: 15px;
}
.beneficiary-container {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  justify-content: space-between;
}

.beneficiary-card {
  flex: 1 1 calc(50% - 20px);
  background-color: white;
  border-radius: 10px;
  border: 1px solid #bfc3ca;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 300px;
}

.info-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.info-field-wrapper {
  display: flex;
  flex-direction: column;
  min-width: 120px;
  flex: 1 1 30%;
}

.info-label {
  font-weight: bold;
  color: #666;
  margin-bottom: 4px;
}

@media (max-width: 960px) {
  .beneficiary-card {
    flex: 1 1 100%;
  }
}
</style>
